import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';
import NoRecievedImagesIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/noRecievedImagesIcon.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import BodyWrapperCorrectiveImagesList from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyFetchedImages/components/bodyWrapperCorrectiveImagesList/BodyWrapperCorrectiveImagesList';
import BodyFetchedCorrectiveImageCard from '@/modules/adjusterReportModules/Insurer-information/components/images/correctiveImages/components/bodyFetchedImages/components/bodyFetchedCorrectiveImageCard/BodyFetchedCorrectiveImageCard';
import { getBodyRecievedCorrectiveImagesOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/getBodyRecievedCorrectiveImages/getBodyRecievedCorrectiveImagesOptions';
import { postBodyAcceptOrRejectRecievedImagesOptions } from '@/modules/adjusterReportModules/Insurer-information/queries/postBodyAcceptOrRejectRecievedImages/postBodyAcceptOrRejectRecievedImagesOptions';
const BodyFetchedCorrectiveImages = () => {
  const { id } = useParams();
  const client = useQueryClient();
  const { data: fetchedData } = useQuery(
    getBodyRecievedCorrectiveImagesOptions({ id: +id! }),
  );
  const { mutate, isPending } = useMutation({
    ...postBodyAcceptOrRejectRecievedImagesOptions(),
    onSuccess: () =>
      client.invalidateQueries({
        queryKey: getBodyRecievedCorrectiveImagesOptions({ id: +id! }).queryKey,
      }),
  });

  return fetchedData?.damaged.length! > 0 ||
    fetchedData?.documents?.length! > 0 ||
    fetchedData?.vehicle?.length! > 0 ? (
    <Flex direction={'column'} gap={'2rem'} mt={16}>
      {fetchedData?.documents?.length! > 0 && (
        <BodyWrapperCorrectiveImagesList headerTitle="مدارک فردی">
          {fetchedData?.documents?.map((item) => (
            <BodyFetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title}
              accept={() =>
                mutate({
                  data: {
                    accepted: true,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              reject={() =>
                mutate({
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </BodyWrapperCorrectiveImagesList>
      )}
      {fetchedData?.vehicle?.length! > 0 && (
        <BodyWrapperCorrectiveImagesList headerTitle="فیلم و تصاویر وسیله‌نقلیه">
          {fetchedData?.vehicle?.map((item) => (
            <BodyFetchedCorrectiveImageCard
              image={item?.image}
              key={item?.id}
              title={item?.title}
              accept={() =>
                mutate({
                  data: {
                    accepted: true,
                    image_id: item?.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              reject={() =>
                mutate({
                  data: {
                    accepted: false,
                    image_id: item?.id,
                    is_damaged: false,
                  },
                  id: +id!,
                })
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </BodyWrapperCorrectiveImagesList>
      )}
      {fetchedData?.damaged?.length! > 0 && (
        <BodyWrapperCorrectiveImagesList headerTitle="نقاط اسیب دیده">
          {fetchedData?.damaged.map((item) => (
            <BodyFetchedCorrectiveImageCard
              image={item.image}
              key={item.id}
              title={item.title}
              accept={() =>
                mutate({
                  data: { accepted: true, image_id: item.id, is_damaged: true },
                  id: +id!,
                })
              }
              reject={() =>
                mutate({
                  data: {
                    accepted: false,
                    image_id: item.id,
                    is_damaged: true,
                  },
                  id: +id!,
                })
              }
              acceptLoading={isPending}
              rejectLoading={isPending}
            />
          ))}
        </BodyWrapperCorrectiveImagesList>
      )}
    </Flex>
  ) : (
    <Box
      w="100%"
      h="60vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      gap={16}
    >
      <NoRecievedImagesIcon />
      <Typography color="black-3" textStyle="b2">
        تصویری دریافت نشده است !
      </Typography>
    </Box>
  );
};

export default BodyFetchedCorrectiveImages;
